// import isEmpty from 'is-empty';

export const GeneratePlayerStats = (gameData) => {
  let playerStatsTeamA = [];
  let playerStatsTeamB = [];


  if (!gameData || !gameData.activityLog) {
    console.error("gameData or activityLog is undefined or null");
    return {
      teamAplayerStats: playerStatsTeamA,
      teamBplayerStats: playerStatsTeamB,
    };
  }
  
  gameData.activityLog.forEach((stats) => {
    let playerAFound = false;
    let playerBFound = false;

    if (stats.team === gameData.teamA.teamName) {
      if (playerStatsTeamA.length === 0) {
        playerStatsTeamA.push({
          player: stats.player,
          jersey: stats.jersey,
          [stats.type]: 1,
          playerRating: stats.rating || 0,
        });
      } else {
        playerStatsTeamA.forEach((v, i) => {
          if (v.player === stats.player) {
            playerAFound = true;
            playerStatsTeamA[i][stats.type] = playerStatsTeamA[i][stats.type]
              ? playerStatsTeamA[i][stats.type] + 1
              : 1;
            playerStatsTeamA[i].playerRating += stats.rating || 0;
          }
          if (playerStatsTeamA.length === i + 1 && !playerAFound) {
            playerStatsTeamA.push({
              player: stats.player,
              jersey: stats.jersey,
              [stats.type]: 1,
              playerRating: stats.rating || 0,
            });
            playerAFound = false;
          }
        });
      }
    }

    if (stats.team === gameData.teamB.teamName) {
      if (playerStatsTeamB.length === 0) {
        playerStatsTeamB.push({
          player: stats.player,
          jersey: stats.jersey,
          [stats.type]: 1,
          playerRating: stats.rating || 0,
        });
      } else {
        playerStatsTeamB.forEach((v, i) => {
          if (v.player === stats.player) {
            playerBFound = true;
            playerStatsTeamB[i][stats.type] = playerStatsTeamB[i][stats.type]
              ? playerStatsTeamB[i][stats.type] + 1
              : 1;
            playerStatsTeamB[i].playerRating += stats.rating || 0;
          }
          if (playerStatsTeamB.length === i + 1 && !playerBFound) {
            playerStatsTeamB.push({
              player: stats.player,
              jersey: stats.jersey,
              [stats.type]: 1,
              playerRating: stats.rating || 0,
            });
            playerBFound = false;
          }
        });
      }
    }
  });

  return {
    teamAplayerStats: playerStatsTeamA,
    teamBplayerStats: playerStatsTeamB,
  };
};

export const GeneratePlayerStatsByPeriod = (
  activityLog,
  numberOfPeriods,
  teamAName,
  teamBName,
  statNames
) => {
  const updatePlayerStats = (playerStats, stat) => {
    const matchingStatName = statNames.find(statName => statName === stat.type);
    const iterations = playerStats[stat.period - 1].length || 0;

    if (matchingStatName) {
      let playerFound = false;
      for (let i = 0; i < iterations; i++) {
        if (playerStats[stat.period - 1][i].player === stat.player) {
          playerStats[stat.period - 1][i][stat.type] =
            (playerStats[stat.period - 1][i][stat.type] || 0) + 1;
          playerFound = true;
          break;
        }
      }
      if (!playerFound) {
        playerStats[stat.period - 1].push({
          player: stat.player,
          jersey: stat.jersey,
          [stat.type]: 1,
        });
      }
    }
  };

  let playerStatsTeamA = Array.from({ length: numberOfPeriods }, () => []);
  let playerStatsTeamB = Array.from({ length: numberOfPeriods }, () => []);

  activityLog.forEach((stats) => {
    if (stats.team === teamAName) {
      updatePlayerStats(playerStatsTeamA, stats);
    } else if (stats.team === teamBName) {
      updatePlayerStats(playerStatsTeamB, stats);
    }
  });

  return {
    teamAplayerStats: playerStatsTeamA,
    teamBplayerStats: playerStatsTeamB,
  };
};
